<template>
    <div class="bg-lightest mt-2">

        <!-- <div class="dark font-weight-600 border-top-light px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100">
            <div class="d-flex flex-row align-items-center">
                <i class="ico ico-ticket color-6 fs-larger"></i>
                <span>VOUCHER CODE</span>
            </div>
            <div class="w-50 d-flex justify-content-end">
                <input type="text" class="w-100 px-2 py-1" v-model="reservation.BookingOperatorCode">
            </div>
        </div> -->

        <!-- <div class="col-sm-12 pt-2">
            <h5>Ticket</h5>
        </div> -->

        <div class="col-sm-12 py-4">

            <div class=" text-center dark pb-3" v-if="noTicketsSelected">
                Empty pax
            </div>

            <table class="w-100 fs-small">
                <template v-if="!noTicketsSelected || totalExtras > 0">
                    <tr>
                        <th></th>
                        <th class="taxWidth text-right">Tax</th>
                        <th class="priceWidth text-right">Price</th>
                    </tr>
                </template>
                <template v-if="!noTicketsSelected">
                    <!-- <span>Ticket</span> -->
                    <template v-for="personType in bookingGenderPrices" v-if="personType.quantityToBook > 0 && audienceTypes">
                        <tr>
                            <td v-if="personType.genderPriceType == 2 || personType.genderPriceType == 1 && personType.isExcludedFromBilling">
                                <div>{{personType.quantityToBook}} x {{genderPriceObj(personType).name}}</div>
                                <div class="dark fs-small">{{genderPriceObj(personType).description}}</div>
                            </td>
                            <td v-else="personType.genderPriceType == 1">Ticket</td>

                            <td class=" text-right" v-if="personType.productGenderPriceComponents.length == 0">{{ (personType.genderPriceType == 2)? personType.vatType + '%':'' }}</td>

                            <td class=" text-right" v-if="personType.productGenderPriceComponents.length != 0">{{ (personType.genderPriceType == 2)? customPerPersonTaxes(personType.productGenderPriceComponents) : '' }}</td>

                            <td class=" text-right">{{ (personType.genderPriceType == 2 || personType.genderPriceType == 1 && personType.isExcludedFromBilling == false)? formatPrice(showTicketPrice(personType) * personType.quantityToBook) + '€' : '' }}</td>

                            <!-- split price breakdown -->

                        </tr>
                        <!-- Split price composition -->
                        <!-- <tr class="dark fs-smaller" v-for="priceComponent in personType.productGenderPriceComponents" v-if="personType.productGenderPriceComponents && personType.productGenderPriceComponents.length > 0">
                            <td class="pl-3">{{priceComponent.component.name}}</td>
                            <td class="text-right">{{priceComponent.selectedPrice.vatType}}%</td>
                            <td class="text-right">{{formatPrice(priceComponent.selectedPrice.grossprice)}} €</td>
                        </tr> -->
                    </template>
                </template>

                <template v-if="totalExtras > 0">
                    <tr>
                        <td class="font-weight-600 pt-2">Extras</td>
                    </tr>
                    <tr v-for="extra in getReservationCalculations.parcels" v-if="extra.itemType == 2 && extra.itemQuantity > 0">
                        <td>{{extra.itemQuantity}} x {{extra.itemNameDescription}}</td>
                        <td class=" text-right">{{ extra.itemVATType }}%</td>
                        <td class=" text-right">{{ formatPrice(extra.itemTotalGrossprice) }} €</td>
                    </tr>
                </template>
            </table>

        </div>
        <!-- <div class="dark font-weight-600 border-top-light px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100">
            <div class="d-flex flex-row align-items-center">
                <i class="ico ico-ticket color-6 fs-larger"></i>
                <span>PROMOCODE</span>
            </div>
            <div class="w-25 d-flex justify-content-end">
                <input type="text" class="w-100 px-2 py-1 text-center" v-model="reservation.billing.promoCode">
            </div>
        </div> -->

        <!-- Discount input -->
        <!-- <div class="dark font-weight-600 border-top-light px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100">
            <div class="d-flex flex-row align-items-center">
                <i class="ico ico-check-in color-6 fs-larger"></i>
                <span>PACKAGE DISCOUNT</span>
            </div>
            <div class="w-25 d-flex justify-content-end">
                <input type="number" class="glued-right px-2 py-1 text-center" style="width: 40px;" v-model.lazy="reservation.attachDiscount.value" placeholder="0" @change="discountChanged">
                <div class="glued-left w-25 p-1 pointer" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 1">%</div>
                <div class="glued-left w-25 p-1 pointer" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 0">€</div>
            </div>
        </div> -->

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'

import {mapActions, mapGetters} from 'vuex'
export default {
    mixins: [
        reservationsMixin
    ],
    data: function() {
        return {
            bookingGenderPrices: null,
            tempExtras: null,
        }
    },
    props: {
        reservation: {
            type: Object
        },
        noTicketsSelected: {
            type: Boolean,
            default: false
        }
    },
    created: function() {
        this.$set(this, 'tempExtras', this.reservation.bookingComponents)
        this.$set(this, 'bookingGenderPrices', this.reservation.bookingGenderPrices)
        // sets attachDiscount valueType if none
        if(this.reservation.attachDiscount == null){
            this.$set(this.reservation, 'attachDiscount', {
                value: 0,
                valueType: 1
            })
        }
    },
    asyncComputed: {
        async audienceTypes() {
            try {
                let response = await axios.get('/api/settings/GetAudienceTypeList');

                if (response && response.status === 200 && response.data && response.data.length > 0) {

                    return response.data;
                }
            }
            catch (error) {
                this.$toasted.error(error);
            }
        },
    },
    computed: {
        ...mapGetters([
            'getReservationCalculations',
            'getReservation',
            'getVatTypes'
        ]),
        isPerOrderWithParticipants: function () {
            return this.reservation.bookingGenderPrices[0].genderPriceType == 1 && this.reservation.bookingGenderPrices.length > 1
        },
        taxes: function () {
            return this.getVatTypes
        },
        hasSelectedExtras: function() {
            if(!this.reservation.bookingComponents.length == 0){
                return false
            } else {
                let output = false;
                for(let extra of this.reservation.bookingComponents){
                    if(extra.quantity > 0){
                        output = true
                    }
                }
                return output
            }
        },
        totalExtras: function(){
            let total = 0;
            for(let extra of this.tempExtras){
                if(extra.quantity){
                    total += Number(extra.quantity)
                }
            }

            return total
        },
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        vatIdToVatType: function(vatId){
            return this.vatTypes.filter(vatType => {
                return vatType.id == vatId
            })[0]
        },
        switchDiscountType: function() {
            if(this.reservation.attachDiscount.valueType == 0){
                this.reservation.attachDiscount.valueType = 1
            } else {
                this.reservation.attachDiscount.valueType = 0
            }

            this.updateCalculations()
        },
        discountChanged: function() {
            if(this.reservation.attachDiscount.valueType == 1 && (this.reservation.attachDiscount.value > 100 || this.reservation.attachDiscount.value < 0)){
                this.$toasted.error('Discount must be between 0 and 100%');
                this.reservation.attachDiscount.value = null
                return false
            }
            if(this.reservation.attachDiscount.valueType == 0 && this.reservation.attachDiscount.value < 0){
                this.$toasted.error('Discount must be higher than 0');
                this.reservation.attachDiscount.value = null
                return false
            }
            this.updateCalculations()
        },
        audienceTypeIdToObj: function (audienceTypeId) {
            if(audienceTypeId) {
                return this.audienceTypes.filter((audienceType) => {
                    return audienceType.id == audienceTypeId;
                })[0]
            } else {
                return null;
            }
        },
        updateCalculations: function () {
            this.validateDiscount()
            this.setReservationCalculations(this.reservation)
        },
        validateDiscount: function () {
            if(this.reservation.attachDiscount.valueType == 0){ // is €
                if(this.reservation.attachDiscount.value > this.getReservationCalculations.grandTotal){
                    // this.reservation.attachDiscount.value = this.getReservationCalculations.grandTotal
                    this.reservation.attachDiscount.value = 0
                    this.$toasted.error('Discount is higher than total, please enter a new value');
                }
            } else { // is %
                if(this.reservation.attachDiscount.value > 100){
                    this.$toasted.error('Discount is higher than 100%, please enter a new value');
                    this.reservation.attachDiscount.value = 0
                }
                // this.reservation.attachDiscount.value = (this.reservation.attachDiscount.value > 100)? null : this.reservation.attachDiscount.value
            }
        },
        customPerPersonTaxes: function(row) {
            let taxes = [];
            for (let service of row) {
                // if(taxes.indexOf(service.component.vatType+'%') == -1){
                //     taxes.push(service.component.vatType+'%')
                // }
                if(service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1){
                    taxes.push(service.component.selectedPrice.vatType+'%')
                }
            }
            return taxes.join(', ')
        },
    }

}
</script>

<style lang="scss">


.taxWidth{
    // width: 15%;
}

.priceWidth{
    width: 20%;
}

table{
    tr{
        th{
            font-weight: 600;
        }

        td{

        }
    }
}

</style>



// WEBPACK FOOTER //
// CostList.vue?c6807f38